import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { reviews } from "@/mocks/movie";

const filters = [
  { key: "all", label: "全部评价" },
  { key: "5", label: "五星好评" },
  { key: "4", label: "四星评价" },
];

export default function Reviews() {
  const [filter, setFilter] = useState("all");

  const visible = reviews.filter((r) => filter === "all" || String(r.rating) === filter);

  return (
    <section id="reviews" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            align="left"
            eyebrow="Reviews"
            title="观众评价：看完之后，他们这样说"
            description="以下评价来自观众与影评人的公开反馈整理，仅代表个人观感。"
          />
          <div className="flex flex-wrap gap-2">
            {filters.map((f) => (
              <button
                key={f.key}
                type="button"
                onClick={() => setFilter(f.key)}
                className={`px-1 py-1 rounded-full cursor-pointer transition-colors ${
                  filter === f.key ? "bg-primary-500" : "bg-background-200"
                }`}
              >
                <span
                  className={`block px-4 py-1.5 rounded-full text-sm whitespace-nowrap ${
                    filter === f.key ? "text-background-50" : "text-foreground-700"
                  }`}
                >
                  {f.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {visible.map((r) => (
            <article
              key={r.name}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 text-accent-500 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`${i < r.rating ? "ri-star-fill" : "ri-star-line"} text-base`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">{r.text}</p>
              <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-sm font-semibold">
                    {r.name.slice(0, 1)}
                  </span>
                  <span className="text-sm font-medium text-foreground-950">{r.name}</span>
                </div>
                <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 whitespace-nowrap">
                  {r.tag}
                </span>
              </div>
            </article>
          ))}
        </div>

        {visible.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">
            这个筛选条件下暂时没有评价，换个分类看看吧。
          </p>
        )}
      </div>
    </section>
  );
}